import styled from "styled-components";
import breakpoints from "../../constants/breakpoints";

export const Styles = styled.div`
  .donate-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    z-index: 9998;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    overflow-y: auto;
    
  }

  .donate-modal-box {
    background: transparent;
    max-width: 900px;
    width: 100%;
    max-height: calc(100vh - 2rem);
    overflow: hidden;
    display: flex;
    gap: 2rem;
    /* box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2); */
    /* min-height: 55vh;
    @media (max-width: ${breakpoints.mackBookAir}) {
      min-height: 75vh;
    } */
  }

  .donate-modal-section-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    background-color: var(--white);
    border-radius: var(--border-radius);
  }

  .donate-modal-image-wrap {
    width: 100%;
    border-radius: var(--border-radius);
    overflow: hidden;
    margin-bottom: 1.5rem;
    aspect-ratio: 4/3;
    background: #f0f0f0;
  }

  .donate-modal-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .donate-modal-title {
    padding: 2rem;
    padding-top: 0;
    padding-bottom: .5rem;
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--main-color);
    text-align: ${({ $isAr }) => ($isAr ? "right" : "left")};
  }

  .donate-modal-description {
    padding: 2rem;
    padding-top: 0;
    font-size: 0.95rem;
    line-height: 1.6;
    color: #4a5568;
    margin: 0;
    text-align: ${({ $isAr }) => ($isAr ? "right" : "left")};
  }

  .donate-modal-section-form {
    flex: 1;
    min-width: 0;
    overflow-y: auto;
    /* min-height: 50vh; */
  }

  .donate-modal-close {
    position: absolute;
    top: 1rem;
    ${({ $isAr }) => ($isAr ? "left: 1rem;" : "right: 1rem;")}
    width: 40px;
    height: 40px;
    border: none;
    background: rgba(0, 0, 0, 0.06);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    color: #4a5568;
    z-index: 10;
    transition:
      background 0.2s,
      color 0.2s;
  }

  .donate-modal-close:hover {
    background: rgba(0, 0, 0, 0.1);
    color: #1a202c;
  }

  .donate-modal-box-wrap {
    position: relative;
  }

  @media (max-width: ${breakpoints.md}) {
    .donate-modal-box {
      flex-direction: column;
      max-height: 90vh;
    }

    .donate-modal-section-content,
    .donate-modal-section-form {
      padding: 1.5rem;
    }

    .donate-modal-image-wrap {
      aspect-ratio: 16/9;
    }
  }
`;
